import { makeStyles } from '@mui/styles';
const darkGray = '#263238';

export const useStyles = makeStyles((theme) => ({
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
    '& .MuiIconButton-root':{
      border: '2px solid #303d8f',
      borderRadius: '50%',
      width: '26px',
      height: '26px',
      padding: '0',
      '& svg':{
        fill: '#303d8f',
        transform: 'scale(0.8)'
      }
    }
  
  },
  operation:{
    fontSize: 13,
    fontWeight: 700,
    color: '#2b3990',
    cursor:'pointer',
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
    '& .MuiButtonBase-root.Mui-disabled': {
      pointerEvents: 'auto !important',
    },
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: darkGray,
    fontSize: 13,
    minWidth: 160,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    minWidth: '200px',
    maxWidth: '200px',
  },
}));